import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useApi, errMsg, ROLE_LABELS, fmtDate } from "@/lib/api";
import { useMe } from "@/context/MeContext";
import { PageHeader } from "@/components/PageHeader";

export default function Accounts() {
  const api = useApi();
  const me = useMe();
  const [data, setData] = useState(null);
  const load = useCallback(() => api("get", "/users").then(setData).catch((e) => toast.error(errMsg(e))), [api]);
  useEffect(() => { load(); }, [load]);

  const change = async (uid, role) => {
    try {
      await api("patch", `/users/${uid}/role`, { role });
      toast.success("Rôle mis à jour");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="space-y-8" data-testid="accounts-page">
      <PageHeader title="Administrateurs" subtitle="Toute personne qui crée un compte arrive « En attente » : attribuez-lui un rôle pour lui donner accès." />
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 text-sm">
        {[["Super-administrateur", "Tout gérer, y compris les comptes et rôles."], ["Administrateur", "Gérer utilisateurs, praticiens, articles et rendez-vous."], ["Modérateur", "Consulter les données et gérer les articles."], ["Observateur", "Consulter uniquement, sans rien modifier (démo)."]].map(([t, d]) => (
          <div key={t} className="bg-white border border-stone-200 rounded-lg p-5"><p className="font-heading font-bold text-stone-900">{t}</p><p className="text-stone-600 mt-1">{d}</p></div>
        ))}
      </div>
      <div className="bg-white border border-stone-200 rounded-lg overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              {["Nom", "E-mail", "Inscrit le", "Rôle"].map((h) => <TableHead key={h} className="text-xs uppercase tracking-[0.1em] text-stone-500">{h}</TableHead>)}
            </TableRow>
          </TableHeader>
          <TableBody>
            {!data && <TableRow><TableCell colSpan={4} className="text-center py-10 text-stone-500">Chargement…</TableCell></TableRow>}
            {data?.users.map((u) => (
              <TableRow key={u.user_id} data-testid={`account-row-${u.user_id}`}>
                <TableCell className="font-medium text-stone-900">{u.name || "—"}{u.user_id === me.user_id && <span className="ml-2 text-xs text-[#C2410C]">(vous)</span>}</TableCell>
                <TableCell className="text-stone-700">{u.email || "—"}</TableCell>
                <TableCell className="text-stone-700">{fmtDate(u.created_at?.slice(0, 10))}</TableCell>
                <TableCell className="w-56">
                  <Select value={u.role} onValueChange={(v) => change(u.user_id, v)}>
                    <SelectTrigger data-testid={`account-role-select-${u.user_id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>{data.roles.map((r) => <SelectItem key={r} value={r}>{ROLE_LABELS[r]}</SelectItem>)}</SelectContent>
                  </Select>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
